enum EModuleIds {
    OVERVIEW = 1,
    OPERATIONS = 2,
    LOGISTICS = 3,
    VENDORS = 4,
    ADMIN = 5,
    SETTINGS = 6,
    FINANCE = 8,
    ONBOARDING = 9,
    THIRDPARTY = 12,
    PROJECTS = 7,
    CUSTOMER_SUPPORT = 11,
    TECHSUPPORT = 10,
    NETWORK_RELIABILITY = 13,
    ACCOUNTS = 14,
    SITES = 15,
    PROGRAMS = 18,
    COMPLAINTS = 19,
    APPROVALS = 20,
    TAGS = 17,
    PURCHASE_ORDERS = 24,
    HANDOVER_TAKEOVER = 25,
}

enum ESubModuleIds {
    INSTALLATION = 1,
    EV_APPLICATION = 2,
    SURVEY = 12,
    DEMOLITION = 21,
}

export default EModuleIds
export { ESubModuleIds }
